import React from 'react';
import moment from 'moment/moment';

export function SentColumnFormatter(cellContent) {
  const {sentTo, sentDate} = cellContent;

  return (
    <div className={'text-dark-75 font-weight-bolder font-size-lg'}>
      <div>{sentTo ? sentTo : ''}</div>
      <div>{sentDate ? moment(sentDate).format('DD-MM-YYYY') : ''}</div>
    </div>
  );
}
